import { BRAND_NAME } from "../../../src/content/brand";
import { isLoggedIn, logout, apiFetch } from "./api";
import { escapeHtml, qs } from "./dom";

interface NavLink {
  label: string;
  href: string;
  disabled?: boolean;
}

interface NavGroup {
  label: string;
  links: NavLink[];
}

const NAV_GROUPS: NavGroup[] = [
  {
    label: "Get Started",
    links: [
      { label: "Start Here", href: "/index.html" },
      { label: "Consultations", href: "#", disabled: true },
    ],
  },
  {
    label: "Build Your Foundation",
    links: [
      { label: "Functional Tests", href: "/tests.html" },
      { label: "Daily Workouts", href: "/workouts.html" },
      { label: "Strong Feet", href: "/course.html?slug=strong-feet" },
      { label: "Power Glutes", href: "/course.html?slug=power-glutes" },
      { label: "Member Chat", href: "#", disabled: true },
    ],
  },
  {
    label: "Resources",
    links: [
      { label: "Gear Guide", href: "/gear.html" },
      { label: "Reading List", href: "/reading.html" },
      { label: "Blog", href: "/blog.html" },
    ],
  },
];

function normalizePath(href: string): string {
  return href.split("?")[0] ?? href;
}

function renderSidebarLinks(): string {
  const currentPath = normalizePath(window.location.pathname);
  return NAV_GROUPS.map((group) => {
    const links = group.links
      .map((link) => {
        if (link.disabled) {
          return `<span class="sidebar-link is-disabled">${escapeHtml(link.label)}<span class="pill muted">Soon</span></span>`;
        }
        const isActive = normalizePath(link.href) === currentPath;
        return `<a class="sidebar-link" href="${link.href}"${isActive ? ' aria-current="page"' : ""}>${escapeHtml(link.label)}</a>`;
      })
      .join("");
    return `<div class="sidebar-group"><div class="sidebar-group-label">${escapeHtml(group.label)}</div>${links}</div>`;
  }).join("");
}

async function renderTopbarActions(): Promise<string> {
  if (!isLoggedIn()) {
    return `<a class="btn secondary" href="/login.html">Log in</a><a class="btn" href="/login.html">Join Free</a>`;
  }
  try {
    const me = await apiFetch<{ email: string; displayName: string | null }>("/api/me");
    const label = me.displayName || me.email;
    return `<span class="pill muted">${escapeHtml(label)}</span><button type="button" class="secondary" id="shell-logout">Log out</button>`;
  } catch {
    return `<a class="btn secondary" href="/login.html">Log in</a><a class="btn" href="/login.html">Join Free</a>`;
  }
}

export async function mountShell(): Promise<void> {
  const root = document.getElementById("shell-root");
  if (!root) return;

  root.innerHTML = `
    <aside class="sidebar" id="shell-sidebar">
      <div class="sidebar-brand"><span class="mark"></span>${escapeHtml(BRAND_NAME)}</div>
      ${renderSidebarLinks()}
    </aside>
    <div>
      <header class="topbar">
        <button type="button" class="hamburger" id="shell-hamburger" aria-label="Toggle menu">&#9776;</button>
        <div class="topbar-actions" id="shell-topbar-actions">Loading&hellip;</div>
      </header>
      <main id="main"></main>
    </div>
  `;

  const hamburger = qs<HTMLButtonElement>("shell-hamburger");
  const sidebar = qs<HTMLElement>("shell-sidebar");
  hamburger.addEventListener("click", () => sidebar.classList.toggle("open"));

  const actions = qs<HTMLElement>("shell-topbar-actions");
  actions.innerHTML = await renderTopbarActions();
  const logoutBtn = document.getElementById("shell-logout");
  logoutBtn?.addEventListener("click", () => logout());
}
